export default "__VITE_ASSET__DmOlZ183__"